/* «Что на фото» — /object-detector.
 *
 * A photo (picked, pasted, or taken with the camera) is scaled to ≤1568 px and
 * redrawn — pixels only, no EXIF — and sent to the server lane
 * (ObjectDetectorAiHandler → PhotoIdentifier), which names what is in it. The
 * answer is rendered as text with textContent only: the model writes content,
 * the page never treats it as markup.
 *
 * The live camera keeps the on-device detector (MediaPipe EfficientDet, 80
 * everyday classes) for one job only: reading the scene aloud continuously for
 * people who cannot see it — no round trip, no daily number.
 *
 * Config comes from the page: window.__OD = { T, LABELS, urls, premiumUrl, speechLang }.
 */
(function () {
    'use strict';
    var C = window.__OD || {};
    var T = C.T || {};
    var LABELS = C.LABELS || {};
    var SLUG = 'object-detector';
    var MAX_SIDE = 1568, QUALITY = 0.88;

    var $ = function (id) { return document.getElementById(id); };
    var show = function (el) { if (el) el.hidden = false; };
    var hide = function (el) { if (el) el.hidden = true; };
    var ae = function (f, p) { try { if (window.__ae) window.__ae('feature_use', Object.assign({ slug: SLUG, f: f }, p || {})); } catch (_) {} };
    var stageMark = function (s, m) { try { if (window.__stage) window.__stage(s, m); } catch (_) {} };
    var toast = function (m, t) { if (window.__toast) window.__toast(m, t || 'info'); };

    var state = { file: null, blob: null, result: null, left: null, cap: null, busy: false, previewUrl: null };

    // ── quota line ───────────────────────────────────────────────────────
    function setQuota(left, cap) {
        if (typeof left === 'number') state.left = left;
        if (typeof cap === 'number') state.cap = cap;
        var el = $('odQuota');
        if (!el || state.cap == null) return;
        el.hidden = false;
        el.textContent = state.cap > 0
            ? T.quota_line.replace(':left', String(Math.max(0, state.left))).replace(':cap', String(state.cap))
            : T.quota_closed;
    }
    function loadQuota() {
        if (!C.urls || !C.urls.quota) return;
        fetch(C.urls.quota, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) {
                if (!j) return;
                if (!j.live) { show($('odOff')); }
                setQuota(j.left, j.cap);
            }).catch(function () {});
    }

    // ── image preparation: pixels only, at a size the model needs ─────────
    // Safari before 17 throws a TypeError on the option itself — then decode without it.
    function orientedBitmap(src) {
        return createImageBitmap(src, { imageOrientation: 'from-image' }).catch(function () { return createImageBitmap(src); });
    }
    function prepare(src) {
        return orientedBitmap(src).then(function (bmp) {
            var k = Math.min(1, MAX_SIDE / Math.max(bmp.width, bmp.height));
            var c = document.createElement('canvas');
            c.width = Math.max(1, Math.round(bmp.width * k));
            c.height = Math.max(1, Math.round(bmp.height * k));
            c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
            if (bmp.close) bmp.close();
            return window.__canvasBlob(c, 'image/jpeg', QUALITY);
        });
    }

    // ── stages ───────────────────────────────────────────────────────────
    function stage(name) {
        ['odInput', 'odCamera', 'odWork'].forEach(function (id) { hide($(id)); });
        show($(name));
    }

    function reset() {
        stopCamera();
        if (state.previewUrl) { try { URL.revokeObjectURL(state.previewUrl); } catch (_) {} }
        state = Object.assign(state, { file: null, blob: null, result: null, previewUrl: null, busy: false });
        $('odAnswer').innerHTML = '';
        $('odQa').innerHTML = '';
        hide($('odAskBox'));
        stage('odInput');
        var up = $('odUpload');
        if (up && up.__uploaderReset) up.__uploaderReset();
    }

    // ── identify ─────────────────────────────────────────────────────────
    function handleImage(file) {
        if (!file || state.busy) return;
        stopCamera();
        state.file = file;
        state.result = null;
        if (state.previewUrl) { try { URL.revokeObjectURL(state.previewUrl); } catch (_) {} }
        state.previewUrl = URL.createObjectURL(file);
        $('odPreview').src = state.previewUrl;
        $('odAnswer').innerHTML = '';
        $('odQa').innerHTML = '';
        hide($('odAskBox'));
        stage('odWork');
        busy(true, T.looking);
        stageMark('analyzing');
        prepare(file).then(function (blob) {
            state.blob = blob;
            return post(C.urls.identify, blob, {});
        }).then(onIdentified).catch(function (e) {
            busy(false);
            renderError(e);
        });
    }
    function onIdentified(j) {
        busy(false);
        state.result = j.result;
        setQuota(j.left, j.cap);
        renderAnswer(j.result, j.second_look);
        show($('odAskBox'));
        renderAskChips(j.result);
        stageMark('identified', { kind: j.result.subject.kind, conf: j.result.subject.confidence });
        try { if (window.__aeToolComplete) window.__aeToolComplete({ kind: j.result.subject.kind, conf: j.result.subject.confidence, second: j.second_look ? 1 : 0 }); } catch (_) {}
        if (j.paid_tokens > 0 && j.paid_text) toast(j.paid_text, 'info');
        if (state.talk) speak(spokenText(j.result));
    }
    /* «Запустить за N токенов» — тот же снимок, уже подготовленный: второй раз
       его не уменьшаем и не перечитываем. Согласие запомнил lane-pay.js. */
    function retryIdentify() {
        if (!state.blob || state.busy) return;
        $('odAnswer').innerHTML = '';
        busy(true, T.looking);
        post(C.urls.identify, state.blob, {}).then(onIdentified).catch(function (e) {
            busy(false);
            renderError(e);
        });
    }

    function post(url, blob, fields) {
        var fd = new FormData();
        fd.append('image', blob, 'photo.jpg');
        Object.keys(fields).forEach(function (k) { fd.append(k, fields[k]); });
        // Согласие на токены (public/js/lane-pay.js): свои снимки Премиума сервер тратит первыми.
        if (window.__lanePay && window.__lanePay.agreed(SLUG)) fd.append('pay', 'tokens');
        var tok = document.querySelector('meta[name="csrf-token"]');
        return fetch(url, {
            method: 'POST', body: fd, credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-CSRF-TOKEN': tok ? tok.content : '' },
        }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) {
                if (!r.ok || !j.success) {
                    var err = new Error(j.error || T.err_failed);
                    err.kind = j.kind || (r.status === 419 ? 'expired' : 'broken');
                    err.premium = !!j.premium;
                    err.status = r.status;
                    // Ответ целиком: в нём цена снимка за токены (`pay`), если она есть.
                    err.data = j;
                    // insufficient_tokens (TokenRefusal) несёт фразу в `msg`, а в `error` — код.
                    if (j.error === 'insufficient_tokens' && j.msg) err.message = j.msg;
                    if (typeof j.left === 'number') setQuota(j.left, state.cap);
                    throw err;
                }
                return j;
            });
        });
    }

    function busy(on, text) {
        state.busy = on;
        var b = $('odBusy');
        if (!b) return;
        b.hidden = !on;
        if (text) $('odBusyText').textContent = text;
    }

    // ── rendering (textContent only) ─────────────────────────────────────
    function el(tag, cls, text) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text != null) e.textContent = text;
        return e;
    }
    var KIND_ICON = { plant: '🌿', tree: '🌳', flower: '🌸', mushroom: '🍄', bird: '🐦', animal: '🦊', pet: '🐾', insect: '🐞', fish: '🐟',
        food: '🍽️', landmark: '🏛️', building: '🏢', artwork: '🖼️', vehicle: '🚗', device: '📱', object: '📦', document: '📄', person: '🧑', place: '📍', other: '🔎' };

    function renderAnswer(r, secondLook) {
        var box = $('odAnswer');
        box.innerHTML = '';
        var s = r.subject;

        var head = el('div', 'od-head');
        head.appendChild(el('div', 'od-kind', KIND_ICON[s.kind] || '🔎'));
        var hb = el('div', 'od-head-body');
        hb.appendChild(el('h2', 'od-name', s.name));
        if (s.latin) hb.appendChild(el('div', 'od-latin', s.latin));
        var badge = el('span', 'od-conf od-conf-' + s.confidence, T['conf_' + s.confidence] || s.confidence);
        badge.title = T['conf_' + s.confidence + '_hint'] || '';
        hb.appendChild(badge);
        head.appendChild(hb);
        box.appendChild(head);

        if (s.safety) {
            var sf = el('div', 'od-safety');
            sf.setAttribute('role', 'alert');
            sf.appendChild(el('b', null, '⚠️ ' + T.safety_title));
            sf.appendChild(el('p', null, s.safety));
            box.appendChild(sf);
        }
        if (r.summary) box.appendChild(el('p', 'od-summary', r.summary));

        section(box, T.sec_features, s.features);
        if (s.lookalikes && s.lookalikes.length) {
            var lk = el('div', 'od-sec');
            lk.appendChild(el('h3', null, T.sec_lookalikes));
            var ul = el('ul', 'od-look');
            s.lookalikes.forEach(function (l) {
                var li = el('li');
                var t = el('b', null, l.name);
                li.appendChild(t);
                if (l.latin) li.appendChild(el('i', 'od-latin-sm', ' ' + l.latin));
                if (l.how_to_tell) li.appendChild(el('div', 'od-how', l.how_to_tell));
                ul.appendChild(li);
            });
            lk.appendChild(ul);
            box.appendChild(lk);
        }
        section(box, T.sec_facts, s.facts);
        if (r.text) {
            var tx = el('div', 'od-sec');
            tx.appendChild(el('h3', null, T.sec_text));
            tx.appendChild(el('blockquote', 'od-text', r.text));
            box.appendChild(tx);
        }
        if (r.objects && r.objects.length) {
            var ob = el('div', 'od-sec');
            ob.appendChild(el('h3', null, T.sec_objects));
            var chips = el('div', 'od-chips');
            r.objects.forEach(function (o) { chips.appendChild(el('span', 'od-chip', o)); });
            ob.appendChild(chips);
            box.appendChild(ob);
        }

        var acts = el('div', 'od-actions');
        acts.appendChild(btn('🔊 ' + T.act_speak, function () { speak(spokenText(r)); ae('od_speak'); }));
        acts.appendChild(btn('📋 ' + T.act_copy, function () { copy(plainText(r)); ae('od_copy'); }));
        rsearchButtons().forEach(function (b) { acts.appendChild(b); });
        if (r.prompt_en) acts.appendChild(btn('✨ ' + T.act_prompt, function () { togglePrompt(r.prompt_en); ae('od_prompt'); }));
        box.appendChild(acts);
        var pr = el('div', 'od-prompt');
        pr.id = 'odPrompt';
        pr.hidden = true;
        box.appendChild(pr);

        var note = el('p', 'od-note', secondLook ? T.note_second_look : T.note_ai);
        box.appendChild(note);
        try { $('odAnswer').focus({ preventScroll: true }); } catch (_) {}
        if (window.__announce) window.__announce(s.name);
    }

    function section(box, title, items) {
        if (!items || !items.length) return;
        var d = el('div', 'od-sec');
        d.appendChild(el('h3', null, title));
        var ul = el('ul', 'od-list');
        items.forEach(function (x) { ul.appendChild(el('li', null, x)); });
        d.appendChild(ul);
        box.appendChild(d);
    }

    function btn(text, fn, cls) {
        var b = el('button', 'od-btn' + (cls ? ' ' + cls : ''), text);
        b.type = 'button';
        b.addEventListener('click', fn);
        return b;
    }

    /* Search by image with THIS photo (ReverseImageSearch): where to buy it,
       where it was published, what the exact model is. Yandex first on the
       Russian page; not on the Ukrainian one (Yandex is blocked in Ukraine). */
    function rsearchButtons() {
        var loc = window.__LOCALE || 'en';
        var order = loc === 'ru' ? ['yandex', 'lens'] : loc === 'uk' ? ['lens'] : ['lens', 'yandex'];
        return order.map(function (engine) {
            return btn('🔎 ' + (engine === 'yandex' ? T.act_yandex : T.act_lens), function () {
                if (!window.ReverseImageSearch) { window.open(engine === 'yandex' ? 'https://yandex.ru/images/' : 'https://lens.google.com/', '_blank', 'noopener'); return; }
                window.ReverseImageSearch.open(engine, state.blob || state.file, { locale: loc, waitText: T.rsearch_wait, slug: SLUG }).then(function (res) {
                    if (!res.ok) toast(res.reason === 'popup_blocked' ? T.rsearch_popup : T.rsearch_failed, 'error');
                });
                ae('od_rsearch', { engine: engine });
            });
        });
    }

    function togglePrompt(p) {
        var box = $('odPrompt');
        if (!box.hidden) { box.hidden = true; return; }
        box.innerHTML = '';
        box.appendChild(el('div', 'od-prompt-h', T.prompt_title));
        box.appendChild(el('code', 'od-prompt-text', p));
        box.appendChild(btn('📋 ' + T.act_copy, function () { copy(p); }));
        box.hidden = false;
    }

    function plainText(r) {
        var s = r.subject, out = [s.name + (s.latin ? ' (' + s.latin + ')' : '')];
        if (s.safety) out.push('⚠️ ' + s.safety);
        if (r.summary) out.push(r.summary);
        (s.facts || []).forEach(function (f) { out.push('• ' + f); });
        return out.join('\n');
    }
    function spokenText(r) {
        var s = r.subject;
        return [s.name + '. ' + (T['conf_' + s.confidence] || ''), s.safety || '', r.summary || ''].filter(Boolean).join('. ');
    }
    function copy(text) {
        var done = function () { toast(T.copied, 'success'); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(done, function () { fallbackCopy(text); done(); });
        } else { fallbackCopy(text); done(); }
    }
    function fallbackCopy(text) {
        var ta = document.createElement('textarea');
        ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (_) {}
        ta.remove();
    }

    function renderError(e) {
        var box = $('odAnswer');
        box.innerHTML = '';
        var d = el('div', 'od-error');
        d.setAttribute('role', 'alert');
        // Отказ с ценой — предложение «за N токенов», а не ошибка: фразу и кнопку
        // рисует lane-pay.js (его «Что даёт Премиум» заменяет свою ссылку).
        var priced = false;
        if (e && e.data && window.__lanePay) {
            var pay = el('div');
            priced = window.__lanePay.show(pay, e.data, { slug: SLUG, run: retryIdentify });
            if (priced) d.appendChild(pay);
        }
        if (!priced) d.appendChild(el('p', null, (e && e.message) || T.err_failed));
        var acts = el('div', 'od-actions');
        if (!priced && e && e.kind === 'limit' && e.premium && C.premiumUrl) {
            var a = el('a', 'od-btn od-btn-primary', T.act_premium);
            a.href = C.premiumUrl;
            acts.appendChild(a);
        }
        // Without the model, search by image still works — and it has no daily number.
        if (state.file) rsearchButtons().forEach(function (b) { acts.appendChild(b); });
        d.appendChild(acts);
        box.appendChild(d);
        stageMark('error', { kind: (e && e.kind) || 'broken' });
        ae('od_error', { kind: (e && e.kind) || 'broken', st: (e && e.status) || 0 });
    }

    // ── questions about the same photo ───────────────────────────────────
    var CHIPS = {
        mushroom: ['q_edible', 'q_lookalike'], plant: ['q_care', 'q_toxic'], flower: ['q_care', 'q_toxic'], tree: ['q_where'],
        bird: ['q_feed', 'q_where'], animal: ['q_danger', 'q_where'], pet: ['q_care', 'q_price'], insect: ['q_danger', 'q_rid'],
        food: ['q_recipe', 'q_calories'], vehicle: ['q_years', 'q_price'], device: ['q_years', 'q_price'], object: ['q_what_for', 'q_price'],
        landmark: ['q_history', 'q_where'], building: ['q_history'], artwork: ['q_author'],
    };
    function renderAskChips(r) {
        var box = $('odAskChips');
        box.innerHTML = '';
        (CHIPS[r.subject.kind] || ['q_more']).forEach(function (k) {
            if (!T[k]) return;
            box.appendChild(btn(T[k], function () { $('odAskInput').value = T[k]; ask(); }, 'od-chip-btn'));
        });
    }
    function ask() {
        var input = $('odAskInput');
        var q = (input.value || '').trim();
        if (!q || state.busy || !state.blob || !state.result) return;
        var s = state.result.subject;
        var ctx = s.name + (s.latin ? ' (' + s.latin + ')' : '') + ' — ' + (state.result.summary || '');
        var item = el('div', 'od-qa-item');
        item.appendChild(el('div', 'od-q', q));
        var ans = el('div', 'od-a', T.thinking);
        item.appendChild(ans);
        $('odQa').appendChild(item);
        input.value = '';
        busy(true, T.thinking);
        ae('od_ask', { kind: s.kind });
        post(C.urls.ask, state.blob, { question: q, context: ctx }).then(function (j) {
            busy(false);
            setQuota(j.left, j.cap);
            if (j.paid_tokens > 0 && j.paid_text) toast(j.paid_text, 'info');
            ans.textContent = j.answer.answer;
            if (j.answer.safety) {
                var sf = el('div', 'od-safety od-safety-sm', '⚠️ ' + j.answer.safety);
                sf.setAttribute('role', 'alert');
                item.appendChild(sf);
            }
            if (state.talk) speak(j.answer.answer);
        }).catch(function (e) {
            busy(false);
            var pay = el('div');
            if (e && e.data && window.__lanePay && window.__lanePay.show(pay, e.data, {
                slug: SLUG, run: function () { item.remove(); $('odAskInput').value = q; ask(); },
            })) {
                ans.remove();
                item.appendChild(pay);
                return;
            }
            ans.textContent = (e && e.message) || T.err_failed;
            ans.classList.add('od-a-err');
            if (e && e.kind === 'limit' && e.premium && C.premiumUrl) {
                var a = el('a', 'od-btn od-btn-primary', T.act_premium);
                a.href = C.premiumUrl;
                item.appendChild(a);
            }
        });
    }

    // ── speech ───────────────────────────────────────────────────────────
    function speak(text) {
        if (!text) return;
        if (window.TTSHelper && window.TTSHelper.isSupported && window.TTSHelper.isSupported()) {
            window.TTSHelper.speak(text, { lang: C.speechLang || 'en-US', rate: 1 });
        } else if (window.__announce) {
            window.__announce(text);
        }
    }

    // ── camera ───────────────────────────────────────────────────────────
    var cam = null, camFacing = 'environment', camRAF = 0, lastSpoken = '', camLast = 0;
    function openCamera() {
        if (!window.CameraManager) { toast(T.err_no_camera, 'error'); return; }
        if (!cam) cam = new window.CameraManager({ slug: SLUG });
        stage('odCamera');
        cam.start({ facingMode: camFacing, width: 1280, height: 720 }).then(function (stream) {
            return cam.show($('odVideo'), stream);
        }).then(function (ok) {
            if (!ok) { stage('odInput'); return; }
            ae('od_camera', { facing: camFacing });
            if (state.talk) startNarration();
        }).catch(function (err) {
            stage('odInput');
            toast((err && err.message) || T.err_no_camera, 'error');
        });
    }
    function stopCamera() {
        if (camRAF) { cancelAnimationFrame(camRAF); camRAF = 0; }
        if (cam) { try { cam.stop(); } catch (_) {} }
        var v = $('odVideo');
        if (v) v.srcObject = null;
    }
    function snap() {
        var v = $('odVideo');
        if (!v || !v.videoWidth) return;
        var c = document.createElement('canvas');
        var k = Math.min(1, MAX_SIDE / Math.max(v.videoWidth, v.videoHeight));
        c.width = Math.round(v.videoWidth * k);
        c.height = Math.round(v.videoHeight * k);
        if (!window.__drawCameraFrame(c.getContext('2d'), v, 0, 0, c.width, c.height)) { toast(T.err_no_camera, 'error'); return; }
        window.__canvasBlob(c, 'image/jpeg', QUALITY).then(function (blob) {
            handleImage(new File([blob], 'camera.jpg', { type: 'image/jpeg' }));
        }).catch(function () { toast(T.err_failed, 'error'); });
        ae('od_snap');
    }

    /* On-device narration (talk mode): MediaPipe EfficientDet names everyday
       objects with their position, no network round trip, no daily number. */
    var detector = null, detLoading = null;
    function loadDetector() {
        if (detector) return Promise.resolve(detector);
        if (detLoading) return detLoading;
        var V = '0.10.14', locale = (window.__LOCALE || 'en').toLowerCase(), origin = location.origin;
        var MODEL = 'efficientdet_lite2/float16/latest/efficientdet_lite2.tflite';
        var libProxy = origin + '/cdn/jsdelivr/npm/@mediapipe/tasks-vision@' + V, libDirect = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + V;
        var mProxy = origin + '/cdn/gstorage/mediapipe-models/object_detector/' + MODEL, mDirect = 'https://storage.googleapis.com/mediapipe-models/object_detector/' + MODEL;
        var libs = locale === 'ru' ? [libProxy, libDirect] : [libDirect, libProxy];
        var models = locale === 'ru' ? [mProxy, mDirect] : [mDirect, mProxy];
        detLoading = (async function () {
            var mod = null, base = null, err = null;
            for (var i = 0; i < libs.length; i++) { try { mod = await import(libs[i] + '/vision_bundle.mjs'); base = libs[i]; break; } catch (e) { err = e; } }
            if (!mod) throw err || new Error('mp-lib');
            var fileset = await mod.FilesetResolver.forVisionTasks(base + '/wasm');
            for (var j = 0; j < models.length; j++) {
                try {
                    var o = { baseOptions: { modelAssetPath: models[j] }, runningMode: 'VIDEO', scoreThreshold: 0.45, maxResults: 12 };
                    if (window.__mpSoftFit) await window.__mpSoftFit(o);
                    detector = await mod.ObjectDetector.createFromOptions(fileset, o);
                    return detector;
                } catch (e) { err = e; }
            }
            throw err || new Error('mp-model');
        })().catch(function (e) { detLoading = null; toast(T.err_narration, 'error'); ae('od_narration_failed', { m: String((e && e.message) || e).slice(0, 80) }); throw e; });
        return detLoading;
    }
    function label(name) { return LABELS[name] || name; }
    function describe(dets, w) {
        if (!dets.length) return T.no_objects;
        var seen = {}, items = [];
        dets.forEach(function (d) { var c = d.categories && d.categories[0]; if (!c) return; var l = label(c.categoryName); if (!seen[l]) { seen[l] = 1; items.push(d); } });
        items.sort(function (a, b) { return (a.boundingBox.originX + a.boundingBox.width / 2) - (b.boundingBox.originX + b.boundingBox.width / 2); });
        return T.speak_intro + ': ' + items.slice(0, 6).map(function (d) {
            var cx = (d.boundingBox.originX + d.boundingBox.width / 2) / w;
            return label(d.categories[0].categoryName) + ' ' + (cx < 0.34 ? T.pos_left : cx > 0.66 ? T.pos_right : T.pos_center);
        }).join(', ');
    }
    function startNarration() {
        loadDetector().then(function () {
            var loop = function () {
                camRAF = requestAnimationFrame(loop);
                var v = $('odVideo');
                if (!state.talk || !v || !v.videoWidth) return;
                var now = performance.now();
                if (now - camLast < 1500) return;
                camLast = now;
                var res = null;
                try { res = detector.detectForVideo(v, now); } catch (_) { return; }
                var phrase = describe((res && res.detections) || [], v.videoWidth);
                $('odSpoken').textContent = phrase;
                if (phrase !== lastSpoken) { lastSpoken = phrase; speak(phrase); }
            };
            loop();
        }).catch(function () {});
    }
    function setTalk(on) {
        state.talk = on;
        $('odTalk').setAttribute('aria-pressed', on ? 'true' : 'false');
        $('odTalk').classList.toggle('on', on);
        show($('odSpoken'));
        if (!on) { $('odSpoken').textContent = ''; hide($('odSpoken')); lastSpoken = ''; }
        if (on && !$('odCamera').hidden) startNarration();
        ae('od_talk', { on: on ? 1 : 0 });
    }

    // ── wiring ───────────────────────────────────────────────────────────
    function bindUploader() {
        var up = $('odUpload');
        var h = function (f) { if (f) handleImage(f); };
        if (typeof window.__bindUploaderFile === 'function') {
            window.__bindUploaderFile(up, function (f, d) { h(f || (d && (d.file || (d.files && d.files[0])))); });
        } else {
            up.addEventListener('tool-uploader:file', function (e) { var d = e.detail || {}; h(d.file || (d.files && d.files[0])); });
        }
    }
    function init() {
        bindUploader();
        $('odCamOpen').addEventListener('click', openCamera);
        $('odSnap').addEventListener('click', snap);
        $('odSwitch').addEventListener('click', function () { camFacing = camFacing === 'environment' ? 'user' : 'environment'; stopCamera(); openCamera(); });
        $('odCamClose').addEventListener('click', function () { stopCamera(); stage('odInput'); });
        $('odTalk').addEventListener('click', function () { setTalk(!state.talk); });
        $('odNew').addEventListener('click', reset);
        $('odAskSend').addEventListener('click', ask);
        $('odAskInput').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); ask(); } });
        // A screenshot or a copied picture: Ctrl+V anywhere on the page.
        document.addEventListener('paste', function (e) {
            var items = (e.clipboardData && e.clipboardData.items) || [];
            for (var i = 0; i < items.length; i++) {
                if (items[i].kind === 'file' && /^image\//.test(items[i].type)) {
                    var f = items[i].getAsFile();
                    if (f) { e.preventDefault(); handleImage(f); ae('od_paste'); }
                    return;
                }
            }
        });
        window.addEventListener('pagehide', stopCamera);
        loadQuota();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
